/**
 * Blueprint motifs — single-weight architectural line drawings.
 * Used as decorative backgrounds at low opacity behind editorial sections.
 */

type SvgProps = React.SVGProps<SVGSVGElement>;

export const FloorPlanFragment = (props: SvgProps) => (
  <svg
    viewBox="0 0 600 400"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="40" y="40" width="520" height="320" />
    <line x1="40" y1="180" x2="320" y2="180" />
    <line x1="320" y1="40" x2="320" y2="360" />
    <line x1="320" y1="240" x2="560" y2="240" />
    <line x1="160" y1="180" x2="160" y2="360" />
    <line x1="440" y1="40" x2="440" y2="240" />
    {/* Door swings */}
    <path d="M 160 220 A 40 40 0 0 1 200 180" />
    <path d="M 320 280 A 40 40 0 0 1 360 240" />
    <path d="M 440 80 A 40 40 0 0 1 480 40" />
    {/* Window dashes */}
    <line x1="80" y1="40" x2="120" y2="40" strokeDasharray="2 4" />
    <line x1="200" y1="40" x2="280" y2="40" strokeDasharray="2 4" />
    <line x1="360" y1="240" x2="420" y2="240" strokeDasharray="2 4" />
    {/* Fixtures */}
    <circle cx="100" cy="240" r="14" />
    <rect x="380" y="280" width="50" height="30" />
  </svg>
);

export const IsometricStack = (props: SvgProps) => (
  <svg
    viewBox="0 0 600 500"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {/* Base */}
    <path d="M 300 460 L 100 360 L 300 260 L 500 360 Z" />
    {/* Floor 2 */}
    <path d="M 300 360 L 140 280 L 300 200 L 460 280 Z" />
    <path d="M 100 360 L 100 320 L 300 220 L 300 260" />
    <path d="M 500 360 L 500 320 L 300 220" />
    {/* Floor 3 */}
    <path d="M 300 280 L 170 215 L 300 150 L 430 215 Z" />
    <path d="M 140 280 L 140 240 L 300 160 L 300 200" />
    <path d="M 460 280 L 460 240 L 300 160" />
    {/* Window grid */}
    <line x1="170" y1="215" x2="240" y2="180" strokeDasharray="3 3" />
    <line x1="430" y1="215" x2="360" y2="180" strokeDasharray="3 3" />
    <line x1="200" y1="320" x2="280" y2="280" strokeDasharray="3 3" />
    <line x1="400" y1="320" x2="320" y2="280" strokeDasharray="3 3" />
  </svg>
);

export const ColumnSection = (props: SvgProps) => (
  <svg
    viewBox="0 0 200 400"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    aria-hidden="true"
    {...props}
  >
    <rect x="60" y="40" width="80" height="320" />
    <line x1="80" y1="40" x2="80" y2="360" />
    <line x1="120" y1="40" x2="120" y2="360" />
    <rect x="40" y="40" width="120" height="20" />
    <rect x="40" y="340" width="120" height="20" />
    {[80, 120, 160, 200, 240, 280].map((y) => (
      <line key={y} x1="60" y1={y} x2="140" y2={y} strokeDasharray="2 4" />
    ))}
  </svg>
);
